
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 20.9424H7C2.59 20.9424 1.25 19.6024 1.25 15.1924V14.6924C1.25 14.2824 1.59 13.9424 2 13.9424C2.96 13.9424 3.75 13.1524 3.75 12.1924C3.75 11.2324 2.96 10.4424 2 10.4424C1.59 10.4424 1.25 10.1024 1.25 9.69238V9.19238C1.25 4.78238 2.59 3.44238 7 3.44238H17C21.41 3.44238 22.75 4.78238 22.75 9.19238V10.1924C22.75 10.6024 22.41 10.9424 22 10.9424C21.04 10.9424 20.25 11.7324 20.25 12.6924C20.25 13.6524 21.04 14.4424 22 14.4424C22.41 14.4424 22.75 14.7824 22.75 15.1924C22.75 19.6024 21.41 20.9424 17 20.9424ZM2.75 15.3524C2.77 18.7924 3.48 19.4424 7 19.4424H17C20.34 19.4424 21.15 18.8524 21.24 15.8524C19.81 15.5124 18.75 14.2224 18.75 12.6924C18.75 11.1624 19.82 9.87238 21.25 9.53238V9.19238C21.25 5.62238 20.58 4.94238 17 4.94238H7C3.48 4.94238 2.77 5.59238 2.75 9.03238C4.18 9.37238 5.25 10.6624 5.25 12.1924C5.25 13.7224 4.18 15.0124 2.75 15.3524Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10 7.44238C9.59 7.44238 9.25 7.10238 9.25 6.69238V4.19238C9.25 3.78238 9.59 3.44238 10 3.44238C10.41 3.44238 10.75 3.78238 10.75 4.19238V6.69238C10.75 7.10238 10.41 7.44238 10 7.44238Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10 14.7725C9.59 14.7725 9.25 14.4325 9.25 14.0225V10.3525C9.25 9.94254 9.59 9.60254 10 9.60254C10.41 9.60254 10.75 9.94254 10.75 10.3525V14.0225C10.75 14.4425 10.41 14.7725 10 14.7725Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10 20.9424C9.59 20.9424 9.25 20.6024 9.25 20.1924V17.6924C9.25 17.2824 9.59 16.9424 10 16.9424C10.41 16.9424 10.75 17.2824 10.75 17.6924V20.1924C10.75 20.6024 10.41 20.9424 10 20.9424Z","fill":"currentColor"}})])
          )
        }
      }
    